import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2afdc248"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about_wrapper" }
const _hoisted_2 = { class: "about--left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "About the Project", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "about--right" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "w-full d-flex mt-4 button-wrapper" }
const _hoisted_8 = { class: "gradient__text d-flex ml-16 mt-8 about-title" }
const _hoisted_9 = ["innerHTML"]

import { watch } from "vue";
import { ref, onMounted, computed } from "vue";
import constants from "@/shared/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutSection',
  setup(__props) {

const screenSizeMobile = computed(() => windowWidth.value < 770);
const screenSize1400 = computed(() => windowWidth.value < 1400);

const windowWidth = ref(window.innerWidth);

const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  // Set up a watch for window width changes
  watch(windowWidth, (newWidth, oldWidth) => {
    console.log("Window width changed from", oldWidth, "to", newWidth);
  });

  // Add a window resize event listener to update the windowWidth value
  window.addEventListener("resize", updateWindowWidth);
});

const isAboutDialogOpen = ref(false);

const showAboutDialog = () => {
  isAboutDialogOpen.value = true;
};

const closeAboutDialog = () => {
  isAboutDialogOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_v_divider, {
          thickness: 4,
          color: "#3AB54A",
          class: _normalizeClass(["border-opacity-100 my-4", { 'w-75': screenSize1400.value }])
        }, null, 8, ["class"]),
        _createElementVNode("span", {
          innerHTML: _unref(constants).about.left,
          class: "text"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!screenSizeMobile.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: _unref(constants).about.right,
              class: "text"
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_v_btn, {
            elevation: 0,
            style: {"background":"transparent"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showAboutDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More "),
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-page-last")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: isAboutDialogOpen.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isAboutDialogOpen).value = $event)),
      overlay: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(constants).about.title), 1),
            _createElementVNode("span", {
              innerHTML: _unref(constants).about.full,
              class: "pop-up_text-box"
            }, null, 8, _hoisted_9),
            _createVNode(_component_v_btn, {
              onClick: closeAboutDialog,
              class: "pop-up_button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Close")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})